'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _userAgent = require('../../../common/userAgent.0.0.3');

var _userAgent2 = _interopRequireDefault(_userAgent);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

var _DropDownSearch = require('../../DropDownSearch');

var _DropDownSearch2 = _interopRequireDefault(_DropDownSearch);

var _AD = require('../img/AD.svg');

var _AD2 = _interopRequireDefault(_AD);

var _AE = require('../img/AE.svg');

var _AE2 = _interopRequireDefault(_AE);

var _AF = require('../img/AF.svg');

var _AF2 = _interopRequireDefault(_AF);

var _AG = require('../img/AG.svg');

var _AG2 = _interopRequireDefault(_AG);

var _AI = require('../img/AI.svg');

var _AI2 = _interopRequireDefault(_AI);

var _AL = require('../img/AL.svg');

var _AL2 = _interopRequireDefault(_AL);

var _AM = require('../img/AM.svg');

var _AM2 = _interopRequireDefault(_AM);

var _AN = require('../img/AN.svg');

var _AN2 = _interopRequireDefault(_AN);

var _AO = require('../img/AO.svg');

var _AO2 = _interopRequireDefault(_AO);

var _AQ = require('../img/AQ.svg');

var _AQ2 = _interopRequireDefault(_AQ);

var _AR = require('../img/AR.svg');

var _AR2 = _interopRequireDefault(_AR);

var _AS = require('../img/AS.svg');

var _AS2 = _interopRequireDefault(_AS);

var _AT = require('../img/AT.svg');

var _AT2 = _interopRequireDefault(_AT);

var _AU = require('../img/AU.svg');

var _AU2 = _interopRequireDefault(_AU);

var _AW = require('../img/AW.svg');

var _AW2 = _interopRequireDefault(_AW);

var _AX = require('../img/AX.svg');

var _AX2 = _interopRequireDefault(_AX);

var _AZ = require('../img/AZ.svg');

var _AZ2 = _interopRequireDefault(_AZ);

var _BA = require('../img/BA.svg');

var _BA2 = _interopRequireDefault(_BA);

var _BB = require('../img/BB.svg');

var _BB2 = _interopRequireDefault(_BB);

var _BD = require('../img/BD.svg');

var _BD2 = _interopRequireDefault(_BD);

var _BE = require('../img/BE.svg');

var _BE2 = _interopRequireDefault(_BE);

var _BF = require('../img/BF.svg');

var _BF2 = _interopRequireDefault(_BF);

var _BG = require('../img/BG.svg');

var _BG2 = _interopRequireDefault(_BG);

var _BH = require('../img/BH.svg');

var _BH2 = _interopRequireDefault(_BH);

var _BI = require('../img/BI.svg');

var _BI2 = _interopRequireDefault(_BI);

var _BJ = require('../img/BJ.svg');

var _BJ2 = _interopRequireDefault(_BJ);

var _BM = require('../img/BM.svg');

var _BM2 = _interopRequireDefault(_BM);

var _BN = require('../img/BN.svg');

var _BN2 = _interopRequireDefault(_BN);

var _BO = require('../img/BO.svg');

var _BO2 = _interopRequireDefault(_BO);

var _BR = require('../img/BR.svg');

var _BR2 = _interopRequireDefault(_BR);

var _BS = require('../img/BS.svg');

var _BS2 = _interopRequireDefault(_BS);

var _BT = require('../img/BT.svg');

var _BT2 = _interopRequireDefault(_BT);

var _BW = require('../img/BW.svg');

var _BW2 = _interopRequireDefault(_BW);

var _BY = require('../img/BY.svg');

var _BY2 = _interopRequireDefault(_BY);

var _BZ = require('../img/BZ.svg');

var _BZ2 = _interopRequireDefault(_BZ);

var _CA = require('../img/CA.svg');

var _CA2 = _interopRequireDefault(_CA);

var _CAF = require('../img/CAF.svg');

var _CAF2 = _interopRequireDefault(_CAF);

var _CAS = require('../img/CAS.svg');

var _CAS2 = _interopRequireDefault(_CAS);

var _CC = require('../img/CC.svg');

var _CC2 = _interopRequireDefault(_CC);

var _CD = require('../img/CD.svg');

var _CD2 = _interopRequireDefault(_CD);

var _CEU = require('../img/CEU.svg');

var _CEU2 = _interopRequireDefault(_CEU);

var _CF = require('../img/CF.svg');

var _CF2 = _interopRequireDefault(_CF);

var _CG = require('../img/CG.svg');

var _CG2 = _interopRequireDefault(_CG);

var _CH = require('../img/CH.svg');

var _CH2 = _interopRequireDefault(_CH);

var _CI = require('../img/CI.svg');

var _CI2 = _interopRequireDefault(_CI);

var _CK = require('../img/CK.svg');

var _CK2 = _interopRequireDefault(_CK);

var _CL = require('../img/CL.svg');

var _CL2 = _interopRequireDefault(_CL);

var _CM = require('../img/CM.svg');

var _CM2 = _interopRequireDefault(_CM);

var _CN = require('../img/CN.svg');

var _CN2 = _interopRequireDefault(_CN);

var _CNA = require('../img/CNA.svg');

var _CNA2 = _interopRequireDefault(_CNA);

var _CO = require('../img/CO.svg');

var _CO2 = _interopRequireDefault(_CO);

var _COC = require('../img/COC.svg');

var _COC2 = _interopRequireDefault(_COC);

var _CR = require('../img/CR.svg');

var _CR2 = _interopRequireDefault(_CR);

var _CSA = require('../img/CSA.svg');

var _CSA2 = _interopRequireDefault(_CSA);

var _CU = require('../img/CU.svg');

var _CU2 = _interopRequireDefault(_CU);

var _CV = require('../img/CV.svg');

var _CV2 = _interopRequireDefault(_CV);

var _CW = require('../img/CW.svg');

var _CW2 = _interopRequireDefault(_CW);

var _CX = require('../img/CX.svg');

var _CX2 = _interopRequireDefault(_CX);

var _CY = require('../img/CY.svg');

var _CY2 = _interopRequireDefault(_CY);

var _CZ = require('../img/CZ.svg');

var _CZ2 = _interopRequireDefault(_CZ);

var _D = require('../img/D0.svg');

var _D2 = _interopRequireDefault(_D);

var _DE = require('../img/DE.svg');

var _DE2 = _interopRequireDefault(_DE);

var _DJ = require('../img/DJ.svg');

var _DJ2 = _interopRequireDefault(_DJ);

var _DK = require('../img/DK.svg');

var _DK2 = _interopRequireDefault(_DK);

var _DM = require('../img/DM.svg');

var _DM2 = _interopRequireDefault(_DM);

var _DO = require('../img/DO.svg');

var _DO2 = _interopRequireDefault(_DO);

var _DZ = require('../img/DZ.svg');

var _DZ2 = _interopRequireDefault(_DZ);

var _EC = require('../img/EC.svg');

var _EC2 = _interopRequireDefault(_EC);

var _EE = require('../img/EE.svg');

var _EE2 = _interopRequireDefault(_EE);

var _EG = require('../img/EG.svg');

var _EG2 = _interopRequireDefault(_EG);

var _ER = require('../img/ER.svg');

var _ER2 = _interopRequireDefault(_ER);

var _ES = require('../img/ES.svg');

var _ES2 = _interopRequireDefault(_ES);

var _ET = require('../img/ET.svg');

var _ET2 = _interopRequireDefault(_ET);

var _EU = require('../img/EU.svg');

var _EU2 = _interopRequireDefault(_EU);

var _FI = require('../img/FI.svg');

var _FI2 = _interopRequireDefault(_FI);

var _FJ = require('../img/FJ.svg');

var _FJ2 = _interopRequireDefault(_FJ);

var _FK = require('../img/FK.svg');

var _FK2 = _interopRequireDefault(_FK);

var _FM = require('../img/FM.svg');

var _FM2 = _interopRequireDefault(_FM);

var _FO = require('../img/FO.svg');

var _FO2 = _interopRequireDefault(_FO);

var _FR = require('../img/FR.svg');

var _FR2 = _interopRequireDefault(_FR);

var _Fl = require('../img/Fl.svg');

var _Fl2 = _interopRequireDefault(_Fl);

var _GA = require('../img/GA.svg');

var _GA2 = _interopRequireDefault(_GA);

var _GB = require('../img/GB.svg');

var _GB2 = _interopRequireDefault(_GB);

var _GD = require('../img/GD.svg');

var _GD2 = _interopRequireDefault(_GD);

var _GE = require('../img/GE.svg');

var _GE2 = _interopRequireDefault(_GE);

var _GF = require('../img/GF.svg');

var _GF2 = _interopRequireDefault(_GF);

var _GG = require('../img/GG.svg');

var _GG2 = _interopRequireDefault(_GG);

var _GH = require('../img/GH.svg');

var _GH2 = _interopRequireDefault(_GH);

var _GI = require('../img/GI.svg');

var _GI2 = _interopRequireDefault(_GI);

var _GL = require('../img/GL.svg');

var _GL2 = _interopRequireDefault(_GL);

var _GM = require('../img/GM.svg');

var _GM2 = _interopRequireDefault(_GM);

var _GN = require('../img/GN.svg');

var _GN2 = _interopRequireDefault(_GN);

var _GP = require('../img/GP.svg');

var _GP2 = _interopRequireDefault(_GP);

var _GQ = require('../img/GQ.svg');

var _GQ2 = _interopRequireDefault(_GQ);

var _GR = require('../img/GR.svg');

var _GR2 = _interopRequireDefault(_GR);

var _GT = require('../img/GT.svg');

var _GT2 = _interopRequireDefault(_GT);

var _GW = require('../img/GW.svg');

var _GW2 = _interopRequireDefault(_GW);

var _GY = require('../img/GY.svg');

var _GY2 = _interopRequireDefault(_GY);

var _HK = require('../img/HK.svg');

var _HK2 = _interopRequireDefault(_HK);

var _HN = require('../img/HN.svg');

var _HN2 = _interopRequireDefault(_HN);

var _HR = require('../img/HR.svg');

var _HR2 = _interopRequireDefault(_HR);

var _HT = require('../img/HT.svg');

var _HT2 = _interopRequireDefault(_HT);

var _HU = require('../img/HU.svg');

var _HU2 = _interopRequireDefault(_HU);

var _ID = require('../img/ID.svg');

var _ID2 = _interopRequireDefault(_ID);

var _IE = require('../img/IE.svg');

var _IE2 = _interopRequireDefault(_IE);

var _IL = require('../img/IL.svg');

var _IL2 = _interopRequireDefault(_IL);

var _IM = require('../img/IM.svg');

var _IM2 = _interopRequireDefault(_IM);

var _IN = require('../img/IN.svg');

var _IN2 = _interopRequireDefault(_IN);

var _IO = require('../img/IO.svg');

var _IO2 = _interopRequireDefault(_IO);

var _IQ = require('../img/IQ.svg');

var _IQ2 = _interopRequireDefault(_IQ);

var _IR = require('../img/IR.svg');

var _IR2 = _interopRequireDefault(_IR);

var _IS = require('../img/IS.svg');

var _IS2 = _interopRequireDefault(_IS);

var _IT = require('../img/IT.svg');

var _IT2 = _interopRequireDefault(_IT);

var _JE = require('../img/JE.svg');

var _JE2 = _interopRequireDefault(_JE);

var _JM = require('../img/JM.svg');

var _JM2 = _interopRequireDefault(_JM);

var _JO = require('../img/JO.svg');

var _JO2 = _interopRequireDefault(_JO);

var _JP = require('../img/JP.svg');

var _JP2 = _interopRequireDefault(_JP);

var _KE = require('../img/KE.svg');

var _KE2 = _interopRequireDefault(_KE);

var _KG = require('../img/KG.svg');

var _KG2 = _interopRequireDefault(_KG);

var _KH = require('../img/KH.svg');

var _KH2 = _interopRequireDefault(_KH);

var _KM = require('../img/KM.svg');

var _KM2 = _interopRequireDefault(_KM);

var _KN = require('../img/KN.svg');

var _KN2 = _interopRequireDefault(_KN);

var _KP = require('../img/KP.svg');

var _KP2 = _interopRequireDefault(_KP);

var _KR = require('../img/KR.svg');

var _KR2 = _interopRequireDefault(_KR);

var _KW = require('../img/KW.svg');

var _KW2 = _interopRequireDefault(_KW);

var _KY = require('../img/KY.svg');

var _KY2 = _interopRequireDefault(_KY);

var _KZ = require('../img/KZ.svg');

var _KZ2 = _interopRequireDefault(_KZ);

var _LA = require('../img/LA.svg');

var _LA2 = _interopRequireDefault(_LA);

var _LB = require('../img/LB.svg');

var _LB2 = _interopRequireDefault(_LB);

var _LC = require('../img/LC.svg');

var _LC2 = _interopRequireDefault(_LC);

var _LI = require('../img/LI.svg');

var _LI2 = _interopRequireDefault(_LI);

var _LK = require('../img/LK.svg');

var _LK2 = _interopRequireDefault(_LK);

var _LR = require('../img/LR.svg');

var _LR2 = _interopRequireDefault(_LR);

var _LS = require('../img/LS.svg');

var _LS2 = _interopRequireDefault(_LS);

var _LT = require('../img/LT.svg');

var _LT2 = _interopRequireDefault(_LT);

var _LU = require('../img/LU.svg');

var _LU2 = _interopRequireDefault(_LU);

var _LV = require('../img/LV.svg');

var _LV2 = _interopRequireDefault(_LV);

var _LY = require('../img/LY.svg');

var _LY2 = _interopRequireDefault(_LY);

var _MA = require('../img/MA.svg');

var _MA2 = _interopRequireDefault(_MA);

var _MC = require('../img/MC.svg');

var _MC2 = _interopRequireDefault(_MC);

var _MD = require('../img/MD.svg');

var _MD2 = _interopRequireDefault(_MD);

var _ME = require('../img/ME.svg');

var _ME2 = _interopRequireDefault(_ME);

var _MG = require('../img/MG.svg');

var _MG2 = _interopRequireDefault(_MG);

var _MH = require('../img/MH.svg');

var _MH2 = _interopRequireDefault(_MH);

var _MK = require('../img/MK.svg');

var _MK2 = _interopRequireDefault(_MK);

var _ML = require('../img/ML.svg');

var _ML2 = _interopRequireDefault(_ML);

var _MM = require('../img/MM.svg');

var _MM2 = _interopRequireDefault(_MM);

var _MN = require('../img/MN.svg');

var _MN2 = _interopRequireDefault(_MN);

var _MO = require('../img/MO.svg');

var _MO2 = _interopRequireDefault(_MO);

var _MQ = require('../img/MQ.svg');

var _MQ2 = _interopRequireDefault(_MQ);

var _MR = require('../img/MR.svg');

var _MR2 = _interopRequireDefault(_MR);

var _MS = require('../img/MS.svg');

var _MS2 = _interopRequireDefault(_MS);

var _MT = require('../img/MT.svg');

var _MT2 = _interopRequireDefault(_MT);

var _MU = require('../img/MU.svg');

var _MU2 = _interopRequireDefault(_MU);

var _MV = require('../img/MV.svg');

var _MV2 = _interopRequireDefault(_MV);

var _MW = require('../img/MW.svg');

var _MW2 = _interopRequireDefault(_MW);

var _MX = require('../img/MX.svg');

var _MX2 = _interopRequireDefault(_MX);

var _MY = require('../img/MY.svg');

var _MY2 = _interopRequireDefault(_MY);

var _MZ = require('../img/MZ.svg');

var _MZ2 = _interopRequireDefault(_MZ);

var _NA = require('../img/NA.svg');

var _NA2 = _interopRequireDefault(_NA);

var _NC = require('../img/NC.svg');

var _NC2 = _interopRequireDefault(_NC);

var _NE = require('../img/NE.svg');

var _NE2 = _interopRequireDefault(_NE);

var _NF = require('../img/NF.svg');

var _NF2 = _interopRequireDefault(_NF);

var _NG = require('../img/NG.svg');

var _NG2 = _interopRequireDefault(_NG);

var _NI = require('../img/NI.svg');

var _NI2 = _interopRequireDefault(_NI);

var _NL = require('../img/NL.svg');

var _NL2 = _interopRequireDefault(_NL);

var _NO = require('../img/NO.svg');

var _NO2 = _interopRequireDefault(_NO);

var _NP = require('../img/NP.svg');

var _NP2 = _interopRequireDefault(_NP);

var _NR = require('../img/NR.svg');

var _NR2 = _interopRequireDefault(_NR);

var _NU = require('../img/NU.svg');

var _NU2 = _interopRequireDefault(_NU);

var _NZ = require('../img/NZ.svg');

var _NZ2 = _interopRequireDefault(_NZ);

var _OM = require('../img/OM.svg');

var _OM2 = _interopRequireDefault(_OM);

var _PA = require('../img/PA.svg');

var _PA2 = _interopRequireDefault(_PA);

var _PE = require('../img/PE.svg');

var _PE2 = _interopRequireDefault(_PE);

var _PF = require('../img/PF.svg');

var _PF2 = _interopRequireDefault(_PF);

var _PG = require('../img/PG.svg');

var _PG2 = _interopRequireDefault(_PG);

var _PH = require('../img/PH.svg');

var _PH2 = _interopRequireDefault(_PH);

var _PK = require('../img/PK.svg');

var _PK2 = _interopRequireDefault(_PK);

var _PL = require('../img/PL.svg');

var _PL2 = _interopRequireDefault(_PL);

var _PM = require('../img/PM.svg');

var _PM2 = _interopRequireDefault(_PM);

var _PR = require('../img/PR.svg');

var _PR2 = _interopRequireDefault(_PR);

var _PS = require('../img/PS.svg');

var _PS2 = _interopRequireDefault(_PS);

var _PT = require('../img/PT.svg');

var _PT2 = _interopRequireDefault(_PT);

var _PW = require('../img/PW.svg');

var _PW2 = _interopRequireDefault(_PW);

var _PY = require('../img/PY.svg');

var _PY2 = _interopRequireDefault(_PY);

var _QA = require('../img/QA.svg');

var _QA2 = _interopRequireDefault(_QA);

var _RE = require('../img/RE.svg');

var _RE2 = _interopRequireDefault(_RE);

var _RO = require('../img/RO.svg');

var _RO2 = _interopRequireDefault(_RO);

var _RS = require('../img/RS.svg');

var _RS2 = _interopRequireDefault(_RS);

var _RU = require('../img/RU.svg');

var _RU2 = _interopRequireDefault(_RU);

var _RW = require('../img/RW.svg');

var _RW2 = _interopRequireDefault(_RW);

var _SA = require('../img/SA.svg');

var _SA2 = _interopRequireDefault(_SA);

var _SB = require('../img/SB.svg');

var _SB2 = _interopRequireDefault(_SB);

var _SC = require('../img/SC.svg');

var _SC2 = _interopRequireDefault(_SC);

var _SD = require('../img/SD.svg');

var _SD2 = _interopRequireDefault(_SD);

var _SE = require('../img/SE.svg');

var _SE2 = _interopRequireDefault(_SE);

var _SG = require('../img/SG.svg');

var _SG2 = _interopRequireDefault(_SG);

var _SH = require('../img/SH.svg');

var _SH2 = _interopRequireDefault(_SH);

var _SI = require('../img/SI.svg');

var _SI2 = _interopRequireDefault(_SI);

var _SK = require('../img/SK.svg');

var _SK2 = _interopRequireDefault(_SK);

var _SL = require('../img/SL.svg');

var _SL2 = _interopRequireDefault(_SL);

var _SM = require('../img/SM.svg');

var _SM2 = _interopRequireDefault(_SM);

var _SN = require('../img/SN.svg');

var _SN2 = _interopRequireDefault(_SN);

var _SO = require('../img/SO.svg');

var _SO2 = _interopRequireDefault(_SO);

var _SR = require('../img/SR.svg');

var _SR2 = _interopRequireDefault(_SR);

var _ST = require('../img/ST.svg');

var _ST2 = _interopRequireDefault(_ST);

var _SV = require('../img/SV.svg');

var _SV2 = _interopRequireDefault(_SV);

var _SY = require('../img/SY.svg');

var _SY2 = _interopRequireDefault(_SY);

var _SZ = require('../img/SZ.svg');

var _SZ2 = _interopRequireDefault(_SZ);

var _TC = require('../img/TC.svg');

var _TC2 = _interopRequireDefault(_TC);

var _TD = require('../img/TD.svg');

var _TD2 = _interopRequireDefault(_TD);

var _TG = require('../img/TG.svg');

var _TG2 = _interopRequireDefault(_TG);

var _TH = require('../img/TH.svg');

var _TH2 = _interopRequireDefault(_TH);

var _TJ = require('../img/TJ.svg');

var _TJ2 = _interopRequireDefault(_TJ);

var _TK = require('../img/TK.svg');

var _TK2 = _interopRequireDefault(_TK);

var _TL = require('../img/TL.svg');

var _TL2 = _interopRequireDefault(_TL);

var _TM = require('../img/TM.svg');

var _TM2 = _interopRequireDefault(_TM);

var _TN = require('../img/TN.svg');

var _TN2 = _interopRequireDefault(_TN);

var _TO = require('../img/TO.svg');

var _TO2 = _interopRequireDefault(_TO);

var _TR = require('../img/TR.svg');

var _TR2 = _interopRequireDefault(_TR);

var _TT = require('../img/TT.svg');

var _TT2 = _interopRequireDefault(_TT);

var _TV = require('../img/TV.svg');

var _TV2 = _interopRequireDefault(_TV);

var _TW = require('../img/TW.svg');

var _TW2 = _interopRequireDefault(_TW);

var _TZ = require('../img/TZ.svg');

var _TZ2 = _interopRequireDefault(_TZ);

var _UA = require('../img/UA.svg');

var _UA2 = _interopRequireDefault(_UA);

var _UG = require('../img/UG.svg');

var _UG2 = _interopRequireDefault(_UG);

var _US = require('../img/US.svg');

var _US2 = _interopRequireDefault(_US);

var _UY = require('../img/UY.svg');

var _UY2 = _interopRequireDefault(_UY);

var _UZ = require('../img/UZ.svg');

var _UZ2 = _interopRequireDefault(_UZ);

var _VA = require('../img/VA.svg');

var _VA2 = _interopRequireDefault(_VA);

var _VC = require('../img/VC.svg');

var _VC2 = _interopRequireDefault(_VC);

var _VE = require('../img/VE.svg');

var _VE2 = _interopRequireDefault(_VE);

var _VG = require('../img/VG.svg');

var _VG2 = _interopRequireDefault(_VG);

var _VN = require('../img/VN.svg');

var _VN2 = _interopRequireDefault(_VN);

var _VU = require('../img/VU.svg');

var _VU2 = _interopRequireDefault(_VU);

var _WF = require('../img/WF.svg');

var _WF2 = _interopRequireDefault(_WF);

var _WS = require('../img/WS.svg');

var _WS2 = _interopRequireDefault(_WS);

var _WW = require('../img/WW.svg');

var _WW2 = _interopRequireDefault(_WW);

var _YE = require('../img/YE.svg');

var _YE2 = _interopRequireDefault(_YE);

var _YT = require('../img/YT.svg');

var _YT2 = _interopRequireDefault(_YT);

var _ZA = require('../img/ZA.svg');

var _ZA2 = _interopRequireDefault(_ZA);

var _ZM = require('../img/ZM.svg');

var _ZM2 = _interopRequireDefault(_ZM);

var _ZW = require('../img/ZW.svg');

var _ZW2 = _interopRequireDefault(_ZW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var images = {
    AD: _AD2.default,
    AE: _AE2.default,
    AF: _AF2.default,
    AG: _AG2.default,
    AI: _AI2.default,
    AL: _AL2.default,
    AM: _AM2.default,
    AN: _AN2.default,
    AO: _AO2.default,
    AQ: _AQ2.default,
    AR: _AR2.default,
    AT: _AT2.default,
    AU: _AU2.default,
    AW: _AW2.default,
    AX: _AX2.default,
    AZ: _AZ2.default,
    BA: _BA2.default,
    BB: _BB2.default,
    BD: _BD2.default,
    BE: _BE2.default,
    BF: _BF2.default,
    BG: _BG2.default,
    BH: _BH2.default,
    BI: _BI2.default,
    BJ: _BJ2.default,
    BM: _BM2.default,
    BN: _BN2.default,
    BO: _BO2.default,
    BR: _BR2.default,
    BS: _BS2.default,
    BT: _BT2.default,
    BW: _BW2.default,
    BY: _BY2.default,
    BZ: _BZ2.default,
    CA: _CA2.default,
    CAF: _CAF2.default,
    CAS: _CAS2.default,
    CD: _CD2.default,
    CEU: _CEU2.default,
    CF: _CF2.default,
    CG: _CG2.default,
    CH: _CH2.default,
    CI: _CI2.default,
    CL: _CL2.default,
    CM: _CM2.default,
    CN: _CN2.default,
    CNA: _CNA2.default,
    CO: _CO2.default,
    COC: _COC2.default,
    CR: _CR2.default,
    CSA: _CSA2.default,
    CU: _CU2.default,
    CV: _CV2.default,
    CY: _CY2.default,
    CZ: _CZ2.default,
    DE: _DE2.default,
    DJ: _DJ2.default,
    DK: _DK2.default,
    DM: _DM2.default,
    DO: _DO2.default,
    DZ: _DZ2.default,
    EC: _EC2.default,
    EE: _EE2.default,
    EG: _EG2.default,
    ER: _ER2.default,
    ES: _ES2.default,
    ET: _ET2.default,
    EU: _EU2.default,
    FI: _FI2.default,
    FJ: _FJ2.default,
    FK: _FK2.default,
    FM: _FM2.default,
    FR: _FR2.default,
    GA: _GA2.default,
    GB: _GB2.default,
    GD: _GD2.default,
    GE: _GE2.default,
    GG: _GG2.default,
    GH: _GH2.default,
    GI: _GI2.default,
    GM: _GM2.default,
    GN: _GN2.default,
    GQ: _GQ2.default,
    GR: _GR2.default,
    GT: _GT2.default,
    GW: _GW2.default,
    GY: _GY2.default,
    HK: _HK2.default,
    HN: _HN2.default,
    HR: _HR2.default,
    HT: _HT2.default,
    HU: _HU2.default,
    ID: _ID2.default,
    IE: _IE2.default,
    IL: _IL2.default,
    IM: _IM2.default,
    IN: _IN2.default,
    IQ: _IQ2.default,
    IR: _IR2.default,
    IS: _IS2.default,
    IT: _IT2.default,
    JE: _JE2.default,
    JM: _JM2.default,
    JO: _JO2.default,
    JP: _JP2.default,
    KE: _KE2.default,
    KG: _KG2.default,
    KH: _KH2.default,
    KM: _KM2.default,
    KN: _KN2.default,
    KP: _KP2.default,
    KR: _KR2.default,
    KW: _KW2.default,
    KY: _KY2.default,
    KZ: _KZ2.default,
    LA: _LA2.default,
    LB: _LB2.default,
    LC: _LC2.default,
    LI: _LI2.default,
    LK: _LK2.default,
    LR: _LR2.default,
    LS: _LS2.default,
    LT: _LT2.default,
    LU: _LU2.default,
    LV: _LV2.default,
    LY: _LY2.default,
    MA: _MA2.default,
    MC: _MC2.default,
    MD: _MD2.default,
    ME: _ME2.default,
    MG: _MG2.default,
    MK: _MK2.default,
    ML: _ML2.default,
    MM: _MM2.default,
    MN: _MN2.default,
    MO: _MO2.default,
    MR: _MR2.default,
    MS: _MS2.default,
    MT: _MT2.default,
    MU: _MU2.default,
    MV: _MV2.default,
    MW: _MW2.default,
    MX: _MX2.default,
    MY: _MY2.default,
    MZ: _MZ2.default,
    NA: _NA2.default,
    NE: _NE2.default,
    NG: _NG2.default,
    NI: _NI2.default,
    NL: _NL2.default,
    NO: _NO2.default,
    NP: _NP2.default,
    NZ: _NZ2.default,
    OM: _OM2.default,
    PA: _PA2.default,
    PE: _PE2.default,
    PF: _PF2.default,
    PG: _PG2.default,
    PH: _PH2.default,
    PK: _PK2.default,
    PL: _PL2.default,
    PR: _PR2.default,
    PT: _PT2.default,
    PW: _PW2.default,
    PY: _PY2.default,
    QA: _QA2.default,
    RO: _RO2.default,
    RS: _RS2.default,
    RU: _RU2.default,
    RW: _RW2.default,
    SA: _SA2.default,
    SB: _SB2.default,
    SC: _SC2.default,
    SD: _SD2.default,
    SE: _SE2.default,
    SG: _SG2.default,
    SH: _SH2.default,
    SI: _SI2.default,
    SK: _SK2.default,
    SL: _SL2.default,
    SM: _SM2.default,
    SN: _SN2.default,
    SO: _SO2.default,
    SR: _SR2.default,
    ST: _ST2.default,
    SV: _SV2.default,
    SY: _SY2.default,
    SZ: _SZ2.default,
    TC: _TC2.default,
    TD: _TD2.default,
    TG: _TG2.default,
    TH: _TH2.default,
    TJ: _TJ2.default,
    TL: _TL2.default,
    TM: _TM2.default,
    TN: _TN2.default,
    TO: _TO2.default,
    TR: _TR2.default,
    TT: _TT2.default,
    TW: _TW2.default,
    TZ: _TZ2.default,
    UA: _UA2.default,
    UG: _UG2.default,
    US: _US2.default,
    UY: _UY2.default,
    UZ: _UZ2.default,
    VC: _VC2.default,
    VE: _VE2.default,
    VG: _VG2.default,
    VN: _VN2.default,
    VU: _VU2.default,
    WS: _WS2.default,
    WW: _WW2.default,
    YE: _YE2.default,
    ZA: _ZA2.default,
    ZM: _ZM2.default,
    ZW: _ZW2.default,
    AS: _AS2.default,
    CC: _CC2.default,
    CK: _CK2.default,
    CW: _CW2.default,
    CX: _CX2.default,
    D0: _D2.default,
    FO: _FO2.default,
    GF: _GF2.default,
    GL: _GL2.default,
    GP: _GP2.default,
    IO: _IO2.default,
    MH: _MH2.default,
    MQ: _MQ2.default,
    NC: _NC2.default,
    NF: _NF2.default,
    NR: _NR2.default,
    NU: _NU2.default,
    PM: _PM2.default,
    PS: _PS2.default,
    RE: _RE2.default,
    TK: _TK2.default,
    TV: _TV2.default,
    VA: _VA2.default,
    WF: _WF2.default,
    YT: _YT2.default
};

var styleReset = {
    idleBorderColor: 'transparent',
    focusBorderColor: 'transparent',
    hoverBorderColor: 'transparent',
    disabledBorderColor: 'transparent',
    errorBorderColor: 'transparent',

    idleBoxShadow: 'none',
    focusBoxShadow: 'none',
    hoverBoxShadow: 'none',
    disabledBoxShadow: 'none',
    errorBoxShadow: 'none',

    idleOutline: 'none',
    focusOutline: 'none',
    hoverOutline: 'none',
    disabledOutline: 'none',
    errorOutline: 'none',

    idleBorderStyle: 'none',
    hoverBorderStyle: 'none',
    focusBorderStyle: 'none',
    errorBorderStyle: 'none',
    disabledBorderStyle: 'none',

    borderWidth: 0,
    display: 'inline-block'
};

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        label = null,
        list = null,
        dropDownTheme = {},
        inputTheme = {},
        selectTemplate = void 0;

    if (this.props.label) {
        label = _react2.default.createElement(
            'div',
            { className: classList.label },
            this.props.label
        );
    }

    if (this.collection && this.collection.length) {
        var name = void 0;

        list = this.collection.map(function (item) {
            name = item.get('name') && item.get('name')[_this.props.lang] || item.get('name').ua;

            return _react2.default.createElement(
                'div',
                {
                    key: item.id,
                    value: item.id,
                    name: name,
                    title: name,
                    className: classList.item
                },
                _react2.default.createElement(
                    'div',
                    { className: classList.itemImg },
                    _react2.default.createElement('img', { src: images[item.get('image')], width: 16 })
                ),
                _react2.default.createElement(
                    'div',
                    { className: classList.itemCode },
                    item.get('dialCode')
                ),
                _react2.default.createElement(
                    'div',
                    { className: classList.itemName },
                    name
                )
            );
        });
    }

    selectTemplate = function selectTemplate(id) {
        var model = _this.collection.get(id),
            name = model.get('name') && model.get('name')[_this.props.lang] || model.get('name').ua;

        if (model) {
            return _react2.default.createElement(
                'div',
                { key: model.id, value: model.id, name: name, title: name, className: classList.item },
                _react2.default.createElement(
                    'div',
                    { className: classList.itemImg },
                    _react2.default.createElement('img', { src: images[model.get('image')], width: 16 })
                ),
                _react2.default.createElement(
                    'div',
                    { className: classList.itemCode },
                    model.get('dialCode')
                )
            );
        } else {
            return null;
        }
    };

    if (this.props.theme) {
        if (this.props.theme.dropDownSearch) {
            // copy for protect initial object
            dropDownTheme = Object.assign({}, this.props.theme.dropDownSearch);
        }

        if (this.props.theme.input) {
            inputTheme = Object.assign({}, this.props.theme.input);
        }

        if (this.props.theme.paddingLeft) {
            dropDownTheme.paddingLeft = this.props.theme.paddingLeft;
            inputTheme.paddingLeft = 0;
        }

        if (this.props.theme.paddingRight) {
            inputTheme.paddingRight = this.props.theme.paddingRight;
            dropDownTheme.paddingRight = 0;
        }
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            onMouseEnter: this._handleHover.bind(this),
            onMouseLeave: this._handleRootBlur.bind(this)
        },
        label,
        _react2.default.createElement(
            'div',
            { className: classList.input },
            _react2.default.createElement(
                _DropDownSearch2.default,
                {
                    value: this.state.code,
                    onChange: this._handleChangeCode.bind(this),
                    disabled: this.props.disabled,
                    readOnly: this.props.readOnly,
                    placeholder: '+380',
                    searchFunc: this._codeSearchFunc.bind(this),
                    selectTemplate: selectTemplate,
                    attribute: this.props.attribute + '-code',
                    theme: Object.assign({}, dropDownTheme, styleReset, classList.code.style)
                },
                list
            ),
            _react2.default.createElement(_Input2.default, {
                elementRef: this._inputRef.bind(this),
                onFocus: this._handleFocus.bind(this),
                onBlur: this._handleBlur.bind(this),
                value: this._numberFormat(this.state.number),
                onChange: this._handleChangeNumber.bind(this),
                onPaste: this._handlePaste.bind(this),
                disabled: this.props.disabled,
                readOnly: this.props.readOnly,
                placeholder: '000000000',
                type: _userAgent2.default.os.isAndroid ? 'number' : 'text',
                attribute: this.props.attribute + '-number',
                theme: Object.assign({}, inputTheme, styleReset, classList.number.style)
            })
        ),
        _react2.default.createElement('hr', { className: classList.border }),
        _react2.default.createElement('hr', { className: classList.activeBorder })
    );
}